import AdminApi from '../services/api';
import swal from 'sweetalert2';
import Loc from "../services/localization";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default{

    props: ['show', 'category'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            hasError: '',
            newColor: '',
            categoryName: '',
            colors: []
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val){
                this.categoryName = this.category.name
                if(this.category.color != null && this.category.color.length > 0){
                    this.colors = this.category.color.split(";").filter(s=> s != null && s.length > 0)
                }
            }
        },
    },

    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeSeeCategoryColors')
        },
        keymonitor: keymonitor,
        reset:reset,
        addNewColor:addNewColor,
        deleteColor:deleteColor,
        updateColors: updateColors,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--medium'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: black;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important; overflow: auto; padding: 15px;';
            }
            return 'height: 600px !important; overflow: auto; padding: 15px;';
        }
    }
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function deleteColor(color){
    this.colors = this.colors.filter(c=> c !== color)
}


function reset(){


}

function updateColors(){
    let _self = this;
    let model = {
        id: this.category.id,
        colors: this.colors,
    }
    _self.isLoading = true;

    AdminApiService.updateArticleCategoryColor(model)
        .then((response) => {
            _self.isLoading = false
            this.$topnavbar.$emit('successSeeCategoryColors')
        })
        .catch(error => {
            _self.isLoading = false
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function addNewColor(){
    if(this.newColor === '') return;
    if(this.newColor.includes(",")) {
        swal('Greška', "Tip treninga ne moze da sadrzi zarez u imenu.", 'error')
        return;
    }
    this.colors.push('' + this.newColor);
    this.newColor = '';
}


// WEBPACK FOOTER //
// ./src/modals/SeeCategoryColors.js